<template>
  <portlet
          :icon="'fad fa-mobile'"
          :title="name"
          :actionsBlock="true"
  >
    <template slot="portletBody">
      <div class="category-container row" style="margin-bottom: 1.5rem">
        <div class="col-10">
            <section-menu 
                :menu="menu" 
                :entry="menuEntry"
                @entryClick="menuClick($event)">
            </section-menu>
        </div>
      </div>
      <hr/>
      <div class="category-container row">
        <div class="col-10">
            <div class="row justify-content-start">
                <div :class="getYearClass(forYear) + ' '" v-for="forYear, key in years" v-bind:key="key" @click="yearClick(forYear)">
                    {{ forYear }}
                </div>
            </div>
        </div>
      </div>
      
      <div class="documents-container row">
        <table class="table-list-h" style="width: 100%; border-spacing: 0">
            <thead>
                <tr>
                    <th>Manager</th>
                    <th>Date Created</th>
                    <th>Date Closed</th>
                    <th>Subject</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr :class="getRowClass(chat)" v-for="chat in chatsOfYearAndStatus()" v-bind:key="chat.id" @click="selectedChat = chat" data-target="#archived-chats-modal" data-toggle="modal" style="cursor: pointer">
                    <td style="padding-right: 0">
                        <div style="border: 2px solid; border-radius: 10px 0 0 10px; border-right: none;">
                            {{ chat.owner.name }}
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            {{ getDateStartFormatted(chat) }}
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            {{ getDateEndFormatted(chat) }}
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            Subject
                        </div>
                    </td>
                    <td style="padding-left: 0;">
                        <div style="border: 2px solid; border-radius: 0 10px 10px 0; border-left: none;">
                            <span style="border: 2px solid; border-radius: 20px; padding: 2px 7px">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                        </div>
                    </td>
                </tr>
                
            </tbody>
        </table>
        <archived-chats-modal
            v-if="true"
            :value="{name: '', rights: []}"
            :name="'archived-chats-modal'"
            :title="'Chat history with: ' + name"
            :chat="selectedChat"
            @saveChanges="updateLeaveRequest($event)"
        >
        </archived-chats-modal>
      </div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import document from '../../components/documents/document.vue';
  import { Can } from '../../../permission/ability.js';
  import sectionMenu from '../../components/documents/sectionMenu.vue'
  import employments from '../../store/employments/employments.js';
  import ArchivedChatsModal from '../../components/archived-chats/archivedChatsModal.vue';

  export default {
  components: { document, sectionMenu, ArchivedChatsModal },
    mixins: [dataTables],
    data() {
      return {
        id: '',
        name: '',
        isAdmin: false,
        documents: [],
        categories: [{name: 'All', id: 'all'}, {name: 'Approved', id: 'approved'}, {name: 'Rejected', id: 'rejected'}, {name: 'Pending', id: 'pending'}],
        years: [],
        year: null,
        category: {name: 'All', id: 'all'},
        employment: null,
        menuEntry: {id:3, name: 'Archived chats'},
        chats: [],
        menu: [{name: 'Leave', id: 1}, {name: 'Documents', id: 2}, {name: 'Archived chats', id: 3}],
        selectedChat: {}
      };
    },
  async   created() {
      this.$store.commit('setLoading',true)
      this.id = parseInt(this.$route.params.employment)
      //this.category = parseInt(this.$route.params.category)
      this.name = this.$route.params.name
      await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;

      if(this.employment === null || this.employment.id !== this.id) {
        let employment = this.getEmployment
        if(employment.id === undefined || employment.id !== this.id) {
            store.dispatch('employments/get', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                if (res.status === 200) {
                    this.employment = res.data.data
                }
            }).catch((err) => {
                console.log(err)
                alert('Unexpected error downloading employments')
            });

        }
      }
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)

        store.dispatch('chats/getChats', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, status: 'open'}).then((res) => {
          if (res.status === 200) {
            this.chats = res.data.data
            
            let years = []
            this.chats.map((document, key) => {
                // Index by employment id
                let year = moment(document.created_at, "YYYY-MM-DD").year()
                
                if(!years.includes(year)) {
                    years.push(year)
                }
            })

            years.sort()
            this.years = years
            this.year = this.years[0]
          }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error with leave requests')
        });

        this.$store.commit('setLoading',false)
      },
      getRowClass(leaveRequest) {
        return 'col-12 ' + leaveRequest.status
      },
      getDateStartFormatted(leaveRequest) {
        return moment(leaveRequest.created_at, "YYYY-MM-DD").format('DD MMMM YYYY')
      },
      getDateEndFormatted(leaveRequest) {
        return moment(leaveRequest.updated_at, "YYYY-MM-DD").format('DD MMMM YYYY')
      },
      setFile(e) {
        if(e.target.files && e.target.files.length > 0) {
            this.file = e.target.files[0]
        } else {
            this.file = null
        }
        
      },
      menuClick(event) {
        this.menuEntry = event
        switch(event.id) {
            case -1:
                this.$router.push('/hours')
            break;
            case 1:
                this.$router.push('/leave-requests/' + this.id + '/' + this.name)
            break;
            case 2:
                this.$router.push('/documents/' + this.id + '/1/' + this.name)
            break;
            case 3:
                this.$router.push('/archived-chats/' + this.id + '/' + this.name)
            break;
        }
      },
      getYear(leaveRequest) {
        return moment(leaveRequest.created_at, 'YYYY-MM-DD').year()
      },
      yearClick(year) {
        this.year = year
      },
      getYearClass(year) {
        return year === this.year ? 'year-widget active' : 'year-widget'
      },
      categoryClick(category) {
        this.category = category
      },
      getCategoryClass(category) {
        return category.id === this.category.id ? 'sub-category-widget active' : 'sub-category-widget'
      },
      getCategory(document) {
        return document.category.id
      },
      getStatus(leaveRequest) {
        return leaveRequest.status
      },
      chatsOfYearAndStatus() {
        // Filter leave requests of the current year
        let t = this.chats.filter((chat, key) => {
            if(this.year === this.getYear(chat) && (this.category.id === 'all' || this.category.id === this.getStatus(chat))) {
                return chat;
            }
        })
        return t
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
      ...mapGetters('employments', [
          'getEmployment'
        ]),
    },
    watch: {
        file(newV, oldV) {
            if(newV !== null) {
                console.log(newV)
                $('.modal').modal('show') ;
            }
        }
    }
  };
</script>

<style lang="scss" scoped>
    .table-list-h {
        .rejected {
            div {
                background-color: #F5CECE;
            }
            color: #D32F2F;
        }
        .approved {
            div {
                background-color: #E5EEF7;
            }
            color: #146F70;
        }
        .pending {
            div {
                background-color: #FBF1EA;
            }
            color: #FF924E;
        }
        th {
            text-align: center;
        }
        td {
            text-align: center;
            div {
                padding: 10px 14px;
                margin-bottom: 1rem;
            }
            .capitalized {
                text-transform: capitalize;
            }
        }
    }
</style>